import { useEffect, useRef } from "react";

/**
 * useEffectOnceWhen - 在指定條件第一次成立時執行 callback。
 *
 * @param {Function} callback - 要在條件成立時執行的副作用函式
 * @param {Function} conditionFn - 傳回 boolean 的條件函式。true 時觸發 callback。
 *
 * @example
 * useEffectOnceWhen(() => {
 *   fetchData();
 * }, () => data.length > 0 && isReady);
 */
const useEffectOnceWhen = (callback, conditionFn) => {
	const hasRun = useRef(false);

	useEffect(() => {
			if (!hasRun.current && conditionFn()) {
				hasRun.current = true;
				callback();
			}
		},
		// eslint-disable-next-line
		[conditionFn]);
};

export default useEffectOnceWhen;
